import { render, staticRenderFns } from "./FacadePaint.vue?vue&type=template&id=81ad12ee&"
import script from "./FacadePaint.vue?vue&type=script&lang=js&"
export * from "./FacadePaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports